const { WebPageJsonLd } = require("next-seo");

const SeoJSON = ({ structuredData }) => {
  if (structuredData === null || structuredData === undefined) {
    return null;
  }
  return (
    <WebPageJsonLd
      description={structuredData.description}
      id={structuredData.id}
    />
  );
};

export default SeoJSON;
